import React, { useEffect, useMemo, useState } from "react";
import { Collapse, Icon, Tooltip } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { IconButton } from "@mui/material";

import { getJobTasks, getJobSiteTasks, getJobOnSiteInfo, getJobHeader } from "../../../../../actions/v2/JobActions";
import { currencyFormat, getStorage } from "../../../../../utils/common";
import { ACCESS_CONTROL } from "../../../../../dataProvider/constant";
import AddNewTask from "./AddNewTask";
// import TaskContractors from "./TaskContractors";
// import IssuePO from "./IssuePO/IssuePO";
// import BatchIssuePO from "./IssuePO/BatchIssuePO";
// import Task from "./Task";
import TaskHeader from "./TaskHeader";


import styles from "../../JobStyle.module.css";
import v2Styles from "../../../v2Styles.module.css";


const { Panel } = Collapse;

export default function TaskList(props) {
  const dispatch = useDispatch();
  const jobTasks = useSelector((state) => state.Job.parentTasks)
  const jobDetails = useSelector((state) => state.Job.jobDetails)
  const isAlreadyInvoiced = useSelector(state =>
    (state.Job.jobHeader && state.Job.jobHeader.ar_job_state && (state.Job.jobHeader.ar_job_state.toLowerCase() === "not found")) ? true : false
  );
  const isInvoiced = useSelector(state => state.Job.jobHeader && state.Job.jobHeader.ar_job_state && state.Job.jobHeader.ar_job_state.toString().toLowerCase() === "invoiced" ? true : false);
  const isPartiallyInvoiced = useSelector(state => state.Job.jobHeader && state.Job.jobHeader.ar_job_state && state.Job.jobHeader.ar_job_state.toString().toLowerCase() === "partially invoiced" ? true : false);

  const isDisabledJob = useSelector(state =>
    isAlreadyInvoiced || (state.Job.jobHeader && (!state.Job.jobHeader.account_managers || (state.Job.jobHeader.account_managers && !state.Job.jobHeader.account_managers.length))) ? true : false
  );
  const siteId = useSelector(state => state.Job.jobHeader && state.Job.jobHeader.hasOwnProperty('site_id') && state.Job.jobHeader.site_id)
  const siteName = useSelector(state => state.Job.jobHeader && state.Job.jobHeader.hasOwnProperty('site_name') && state.Job.jobHeader.site_name)

  const [addNewTask, setAddNewTask] = useState(false);
  const [activeKey, setActiveKey] = useState(null);

  useEffect(() => {
    if (props.jobId) {
      dispatch(getJobTasks(props.jobId))
    }
  }, [props.jobId])

  const toggleAddNewTask = () => {
    setAddNewTask(!addNewTask);
  }

  const refreshJobBoard = () => {
    if (props.jobId) {
      props.onReload();
      Promise.all([
        dispatch(getJobHeader(props.jobId)),
        dispatch(getJobTasks(props.jobId)),
        dispatch(getJobSiteTasks(props.jobId)),
        dispatch(getJobOnSiteInfo(props.jobId)),
      ])
    }
  }

  const permissions = useMemo(() => {
    try {
      const calPermissions = JSON.parse(getStorage(ACCESS_CONTROL))["calendar"]
      const accessControl = calPermissions && calPermissions.permissions ? calPermissions.permissions : [];

      const modulePermissions = {
        viewJobTaskCost: accessControl.findIndex(access => access.control_name === "sf_view_task_job_value_view_task_job_value"),
      }
      return modulePermissions;
    } catch (e) {
      return {}
    }
  }, []);

  const canSeeValues = useMemo(() => {
    if (!permissions) return false;
    return permissions.viewJobTaskCost !== -1;
  }, [permissions]);

  const togglePanelKey = (key) => {
    if (activeKey !== key) {
      setActiveKey(key)
    } else {
      setActiveKey(null)
    }
  }

  return (
    <div>
      <div className={`${styles.JobTasksListContainer}`}>
        <div className={styles.JobTaskHeadRow}>
          <div className="container-fluid">
            <div className="row align-items-center">
              <div className="col-4">
                <div className={styles.JobListHeading}>{jobDetails && jobDetails.job_number && jobDetails.job_number}
                  <Tooltip title="Reload Job Board"><Icon type="sync" onClick={() => refreshJobBoard()} className={`ml-1 ${styles.JobListHeadingIcon}`} /></Tooltip></div>
                <div>{jobDetails && jobDetails.job_number && jobDetails.job_name}</div>
              </div>
              <div className="col-8">
                <div className="container-fluid">
                  <div className="row align-items-center">
                    <div className="col-2 px-0">{jobDetails && jobDetails.job_total_amount && canSeeValues ? currencyFormat(jobDetails.job_total_amount) : ''}</div>
                    <div className="col-3 pl-0">
                      <div className={`${styles.jobStatusBox} job-board-status-${jobDetails && jobDetails.job_state ? jobDetails.job_state.toLowerCase().replaceAll(" ", "") : ""}`}>
                        <div>
                          {jobDetails && jobDetails.job_state && jobDetails.job_state}
                        </div>
                      </div>
                    </div>
                    <div className="col-1 px-0 d-flex">
                      {isInvoiced ? (
                        <Tooltip title="Invoiced">
                          <span>
                            <IconButton className={`${v2Styles.IconBtn} ${v2Styles.PrimaryColor}`} style={{ height: "auto" }}>
                              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640" style={{ width: "26px", height: "26px" }}>
                                <path fill="currentColor" d="M128 128C128 92.7 156.7 64 192 64L341.5 64C358.5 64 374.8 70.7 386.8 82.7L493.3 189.3C505.3 201.3 512 217.6 512 234.6L512 512C512 547.3 483.3 576 448 576L192 576C156.7 576 128 547.3 128 512L128 128zM336 122.5L336 216C336 229.3 346.7 240 360 240L453.5 240L336 122.5zM192 152C192 165.3 202.7 176 216 176L264 176C277.3 176 288 165.3 288 152C288 138.7 277.3 128 264 128L216 128C202.7 128 192 138.7 192 152zM192 248C192 261.3 202.7 272 216 272L264 272C277.3 272 288 261.3 288 248C288 234.7 277.3 224 264 224L216 224C202.7 224 192 234.7 192 248zM304 324L304 328C275.2 328.3 252 351.7 252 380.5C252 406.2 270.5 428.1 295.9 432.3L337.6 439.3C343.6 440.3 348 445.5 348 451.6C348 458.5 342.4 464.1 335.5 464.1L280 464C269 464 260 473 260 484C260 495 269 504 280 504L304 504L304 508C304 519 313 528 324 528C335 528 344 519 344 508L344 503.3C369 499.2 388 477.6 388 451.5C388 425.8 369.5 403.9 344.1 399.7L302.4 392.7C296.4 391.7 292 386.5 292 380.4C292 373.5 297.6 367.9 304.5 367.9L352 367.9C363 367.9 372 358.9 372 347.9C372 336.9 363 327.9 352 327.9L344 327.9L344 323.9C344 312.9 335 303.9 324 303.9C313 303.9 304 312.9 304 323.9z" />
                              </svg>
                            </IconButton>
                          </span>
                        </Tooltip>
                      ) : null}
                      {isPartiallyInvoiced ? (
                        <Tooltip title="Partially Invoiced">
                          <span>
                            <IconButton className={`${v2Styles.IconBtn} ${v2Styles.PrimaryColor}`} style={{ height: "auto" }}>
                              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640" style={{ width: "26px", height: "26px" }}>
                                <path fill="currentColor" d="M192 64C156.7 64 128 92.7 128 128L128 384L512 384L512 234.5C512 217.5 505.3 201.2 493.3 189.2L386.7 82.7C374.7 70.7 358.5 64 341.5 64L192 64zM453.5 240L360 240C346.7 240 336 229.3 336 216L336 122.5L453.5 240zM128 416L128 480L192 480L192 416L128 416zM192 576L192 512L128 512C128 547.3 156.7 576 192 576zM224 576L304 576L304 512L224 512L224 576zM336 576L416 576L416 512L336 512L336 576zM448 576C483.3 576 512 547.3 512 512L448 512L448 576zM512 416L448 416L448 480L512 480L512 416z" />
                              </svg>
                            </IconButton>
                          </span>
                        </Tooltip>
                      ) : null}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Collapse
          bordered={false}
          className={styles.Collapse}
          accordion
          activeKey={activeKey}
          expandIcon={({ isActive, showIcon = true }) => (
            <Icon
              type={isActive ? "minus" : "plus"}
              className={`${styles.blueText} ${!showIcon ? styles.transparentIcon : ''}`}
            />
          )}
        >
          {jobTasks && jobTasks.map((task, i) => (<React.Fragment key={task.task_number}>
            <Panel
              className={`${styles.Panel} job-board-default-panel-cursor ${task.task_type === "JOB_TASK" ? "job-board-v2-panel-part" : ""} ${i === 0 ? "mt-0" : ""}`}
              header={
                <TaskHeader
                  refreshJobBoard={refreshJobBoard}
                  onActive={() => togglePanelKey(task.task_number)}
                  isDisabledJob={isDisabledJob}
                  taskDetails={task}
                  job={jobDetails}
                  canSeeValues={canSeeValues}
                  setSelectedTask={props.setSelectedTask}
                />
              }
              // disabled={true}
              isActive={activeKey === task.task_number}
              showIcon={false}
              openAnimation={Collapse.defaultProps.openAnimation}
              expandIcon={({ isActive, showIcon = true }) => showIcon ? (
                <Icon onClick={() => togglePanelKey(task.task_number)}
                  type={isActive ? "minus" : "plus"}
                  className={`${styles.PrimaryText} ${!showIcon ? styles.transparentIcon : ''} ant-collapse-arrow`}
                />) : null}
            >
              {/* {task.quote_task_id && task.task_type !== "JOB_TASK" && <Task isDisabledJob={isDisabledJob} taskDetails={task} jobId={props.jobId} />} */}
            </Panel>
            {/* <Panel className={`${styles.PartPanel} job-board-panel-part job-board-v2-panel-part`} disabled
              header={<TaskContractors
                task={task}
                jobId={props.jobId}
                tasks={jobTasks}
                siteId={siteId}
                isDisabledJob={isDisabledJob}
                siteName={siteName}
                setSelectedTask={props.setSelectedTask}
                job={jobDetails}
                refreshJobBoard={refreshJobBoard}
              />}
              showIcon={false} /> */}

          </React.Fragment>)
          )}
        </Collapse>
        <div>
          {addNewTask &&
            <AddNewTask onClose={toggleAddNewTask} job={jobDetails} />
          }
        </div>
        <div className="d-flex align-items-center">
          {/* {!isFullyInvoiced && <button className={`${!addNewTask ? styles.SecondaryButton : styles.FilterResetButton} my-3 mx-2`}
          onClick={() => toggleAddNewTask()} disabled={isDisabledJob}>
          {!addNewTask ? 'Add New Task' : 'Cancel'}
        </button>} */}
          {isAlreadyInvoiced ? <span className="text-danger" >This job is already Invoiced.</span> : isDisabledJob ? <span className="text-danger">Manager is not allocated for this job.</span> : ''}
        </div>
        {jobDetails.conditions && jobDetails.conditions !== "" ?
          <div className="p-2" style={{ borderTop: '1px solid #e5e5e5' }}>
            <div className="font-weight-bold">Special Notes</div>
            <div className="custom-htmlBox px-3" dangerouslySetInnerHTML={{ __html: jobDetails.conditions }}></div>
          </div>
          : ''}
      </div>
      <div className="mt-3">
        {/* <BatchIssuePO
          tasks={jobTasks}
          jobId={props.jobId}
          siteId={siteId}
          jobLabel={jobDetails.job_label}
          siteName={siteName}
          refreshJobBoard={refreshJobBoard}
        /> */}
      </div>
    </div>
  );
}
